import ScrollTop from 'components/ScrollTop';
import { SnackbarProvider } from 'components/snackbar/snackbarProvider';
import { ConfirmDialogProvider } from 'contexts/ConfirmDialogContext';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

// project imports
import router from 'routes';
import { AuthProvider } from 'sections/authentication/context/AuthProvider';
import { InspectorProvider } from 'features/inspector/contexts/InspectorContext';

import ThemeCustomization from 'themes';

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN as string;
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE as string;

const App: React.FC = () => {
  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: auth0Audience,
        scope: 'openid profile email'
      }}
    >
      <ThemeCustomization>
        <ScrollTop>
          <AuthProvider>
            <ConfirmDialogProvider>
              <SnackbarProvider>
                <InspectorProvider>
                <RouterProvider router={router} />
                </InspectorProvider>
            </SnackbarProvider>
            </ConfirmDialogProvider>
          </AuthProvider>
        </ScrollTop>
      </ThemeCustomization>
    </Auth0Provider>
  );
};

export default App;
